import { render, staticRenderFns } from "./TaskStatusAlert.vue?vue&type=template&id=2e3cf8e8&scoped=true"
import script from "./TaskStatusAlert.vue?vue&type=script&lang=ts"
export * from "./TaskStatusAlert.vue?vue&type=script&lang=ts"
import style0 from "./TaskStatusAlert.vue?vue&type=style&index=0&id=2e3cf8e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3cf8e8",
  null
  
)

export default component.exports